import React from 'react';
import { Table } from 'antd';
const columns = [
  {
    title: 'User Name',
    dataIndex: 'user_name',
    // width: 150,
  },
  {
    title: 'Activity Time',
    dataIndex: 'created_at',
  },
];
const ActiveUser = (props) => (
  
  <Table
    className='wday-table'
    columns={columns}
    dataSource={props.recentActivity}
    pagination={false}
    size="small"
    scroll={{
      y: 200,
    }}
  />
);

export default ActiveUser;

